import {
  addData,
  changePassword,
  getProfile,
  setData,
  updateProfile,
} from '@/actions/auth';
import { CountryCodeSelector } from '@/helpers/CountryCodeSelector';
import { removeImageKeyFromObj } from '@/helpers/dataHelper';
import formDataHelper, { blockInvalidChar } from '@/helpers/formDataHelper';
import useWidth, { IBooleanArgs } from '@/helpers/widthUtil';
import { EditOutlined } from '@ant-design/icons';
import { Avatar, Button, Form, Input, notification, Select } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import classnames from 'classnames';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { IAuth } from 'src/interfaces/auth';
import { INotification } from 'src/interfaces/notifications';
import { Url } from 'url';

type ProfileEditForm = {
  first_name: string;
  last_name: string;
  avatar: Url | string;
  country_code: string | number;
  biography: string;
  phone_number: string | number;
  gender: string;
  country: string;
  city: string;
};

type PasswordFormType = {
  old_password: string;
  new_password: string;
};

const ProfileSettingsComponent: FC<{}> = () => {
  const { isMobile }: IBooleanArgs = useWidth();
  const [editForm] = Form.useForm<ProfileEditForm>();
  const [passwordForm] = Form.useForm<PasswordFormType>();
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [error, setError] = useState<string>(null);
  const [activeTab, setActiveTab] = React.useState<string>('1');
  const [password, setPassword] = useState<string>('');
  const [file, setfile] = useState<File>(null);

  const toggle = (tab: string): void => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const dispatch = useDispatch();
  const profile = useSelector((state: RootStateOrAny) => state?.auth?.profile?.data);
  const {
    reviewNotification,
    userRole,
    passwordError,
    changeStatus,
    updateProfileStatus,
  }: {
    reviewNotification: INotification['sendNotificationForReview'];
    userRole: IAuth['profile']['data'];
    passwordError: IAuth['changePassword']['error'] | {} | any;
    changeStatus: IAuth['changePassword']['status'];
    updateProfileStatus: IAuth['updateProfileStatus'] | string;
  } = useSelector((state: RootStateOrAny) => ({
    reviewNotification: state?.notificationReducer?.sendNotificationForReview,
    userRole: state.auth?.profile?.data?.user_type,
    passwordError: state?.auth?.changePassword?.error,
    changeStatus: state?.auth?.changePassword?.status,
    updateProfileStatus: state.auth.updateProfileStatus,
  }));

  useEffect(() => {
    if (changeStatus) {
      notification.success({ message: 'Password changed successfully' });
    }
    if (Object.keys(passwordError).length !== 0) {
      notification.error({ message: passwordError });
      dispatch(
        setData({
          name: 'changePassword',
          key: 'error',
          value: {},
        })
      );
    }
  }, [changeStatus, passwordError]);

  useEffect(() => {
    if (updateProfileStatus === 'success') {
      notification.success({ message: 'Profile updated successfully' });
      dispatch(addData({ key: 'updateProfileStatus', value: '' }));
    }
  }, [updateProfileStatus]);

  useEffect(() => {
    dispatch(getProfile());
    dispatch(
      setData({
        name: 'changePassword',
        key: 'status',
        value: JSON.parse('false'),
      })
    );
    dispatch(
      setData({
        name: 'changePassword',
        key: 'error',
        value: {},
      })
    );
    dispatch(addData({ key: 'updateProfileStatus', value: '' }));
    return () => {};
  }, []);

  useEffect(() => {
    if (profile) {
      editForm.setFieldsValue({
        first_name: profile?.first_name,
        last_name: profile?.last_name,
        biography: profile?.biography,
        country_code: profile?.country_code,
        phone_number: profile?.phone_number,
        gender:
          profile.gender === 0
            ? 'Male'
            : profile.gender === 1
            ? 'Female'
            : profile.gender === 2
            ? 'Other'
            : null,
        // : 'Choose Gender',
        country: profile?.country,
        city: profile?.city,
      });
    }
  }, [profile]);
  console.log({ profile });

  const normFile = (e: ChangeEvent) => {
    const avatarImg: HTMLImageElement = document.querySelector(
      '.user-profile-img img'
    );
    avatarImg.src = URL.createObjectURL((e.target as HTMLInputElement).files[0]);
    setfile((e.target as HTMLInputElement).files[0]);
  };
  const handleEditForm = (values: ProfileEditForm) => {
    const genderFormattedValues = {
      ...values,
      gender:
        values.gender === 'Male'
          ? 0
          : values.gender === 'Female'
          ? 1
          : values.gender === 'Other'
          ? 2
          : undefined,
    };
    let value: object;
    if (file) {
      value = formDataHelper(genderFormattedValues, { avatar: file });
    } else {
      let imgRemoval: Function = removeImageKeyFromObj(
        genderFormattedValues,
        'avatar'
      );
      value = formDataHelper(imgRemoval, {});
    }
    dispatch(updateProfile(value));
  };
  const handleSelectFilter = (name: string, val: ChangeEvent): void => {
    dispatch(
      setData({
        name: 'user',
        key: name,
        value: val,
      })
    );
  };
  const handlePasswordChange = async (values: object | any): Promise<void> => {
    if (values?.new_password === confirmPassword) {
      if (values?.new_password?.length < 8) {
        dispatch(
          setData({
            name: 'changePassword',
            key: 'error',
            value: 'Password must contain atleast 8 characters',
          })
        );
        setError('Password must contain atleast 8 characters');
      } else {
        setError('');
        dispatch(changePassword(values));
      }
    } else {
      setError('Passwords do not match');
    }
  };
  const handleConfirmPassword = (e: ChangeEvent, type: string) => {
    const eventTarget = e.target as HTMLInputElement;
    if (type === 'new') {
      setPassword(eventTarget.value);
      if (confirmPassword) {
        confirmPassword !== eventTarget.value
          ? setError('Passwords do not match')
          : setError('');
      }
    } else {
      setConfirmPassword(eventTarget.value);
      password !== eventTarget.value
        ? setError('Passwords do not match')
        : setError('');
    }
  };
  return (
    <>
      <h3 className="text-dark mb-3 col">
        <img
          src={'/images/svgs/dashboard/setting stroke.svg'}
          width={'32px'}
          height="32px"
        />{' '}
        Profile & Settings
      </h3>
      <div>
        <Nav className="border-bottom">
          <NavItem className="d-flex flex-row">
            <NavLink
              className={classnames(
                activeTab === '1' ? 'font-weight-bold text-muted' : 'text-muted'
              )}
              style={
                activeTab === '1'
                  ? { borderBottom: '3px solid #6c757d' }
                  : { borderBottom: '0px' }
              }
              onClick={() => {
                toggle('1');
              }}
            >
              Profile Details
            </NavLink>
            <NavLink
              className={classnames(
                activeTab === '2' ? 'font-weight-bold text-muted' : 'text-muted'
              )}
              style={
                activeTab === '2'
                  ? { borderBottom: '3px solid #6c757d' }
                  : { borderBottom: '0px' }
              }
              onClick={() => {
                toggle('2');
              }}
            >
              Password Settings
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <Form
              form={editForm}
              style={{ paddingTop: '32px', paddingBottom: '32px' }}
            >
              <div
                key={'2'}
                className="user-profile-img d-flex justify-content-center mb-2"
              >
                {profile?.avatar ? (
                  <Avatar size={95} src={profile?.avatar} />
                ) : (
                  <Avatar
                    size={95}
                    src={'/images/author.png'}
                    style={{
                      backgroundColor: '#fff',
                      border: '2px solid #f0f2f5',
                    }}
                  >
                    {profile?.first_name?.charAt(0)}
                    {profile?.last_name?.charAt(0)}
                  </Avatar>
                )}
                {isMobile && <br />}
                <Button
                  className={`edit-profile ${
                    isMobile ? 'mt-2' : 'user-img-overlay-icon'
                  }`}
                >
                  <Form.Item key={'0'} className="add-image-form-item" name="avatar">
                    <input id="add-image-input" type="file" onChange={normFile} />
                  </Form.Item>
                  <label htmlFor="add-image-input" style={{ cursor: 'pointer' }}>
                    {isMobile ? 'Change Avatar' : <EditOutlined rev="" />}
                  </label>
                </Button>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <Form.Item key={'1'} name="first_name" label="First Name" required>
                    <Input
                      placeholder="First Name"
                      required={true}
                      size="large"
                      className="border-14"
                    />
                  </Form.Item>
                </div>
                <div className="col-lg-6">
                  <Form.Item key={'2'} label="Last Name" name="last_name" required>
                    <Input
                      placeholder="Last Name"
                      required
                      size="large"
                      className="border-14"
                    />
                  </Form.Item>
                </div>
              </div>
              {profile?.user_type === 'instructor' ? (
                <Form.Item name="biography" key={'3'} label="Biography">
                  <TextArea
                    name="text"
                    rows={4}
                    style={{ resize: 'none' }}
                    placeholder={'About yourself'}
                  />
                </Form.Item>
              ) : null}
              <div className="row">
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-lg-4">
                      <Form.Item key={'4'} name="country_code" label="Code">
                        <CountryCodeSelector
                          onChange={(val) => handleSelectFilter('country_code', val)}
                          defaultValue={'+977'}
                          disabled={profile?.is_phone_number_verified}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-lg-8">
                      <Form.Item key={'6'} label="Phone Number" name="phone_number">
                        <Input
                          placeholder="Phone Number"
                          type="number"
                          onKeyDown={blockInvalidChar}
                          size="large"
                          className="border-14"
                          disabled={profile?.is_phone_number_verified}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <Form.Item
                    key={'5'}
                    name="gender"
                    label="Gender"
                    rules={[{ required: true }]}
                  >
                    <Select
                      size="large"
                      className="border-14"
                      placeholder="Choose Gender"
                    >
                      <Select.Option value="Male">Male</Select.Option>
                      <Select.Option value="Female">Female</Select.Option>
                      <Select.Option value="Other">Other</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <Form.Item key={'7'} label="Country" name="country">
                      <Input
                        placeholder="Country"
                        size="large"
                        className="border-14"
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="col-lg-6">
                  <Form.Item key={'8'} label="City" name="city">
                    <Input placeholder="City" size="large" className="border-14" />
                  </Form.Item>
                </div>
              </div>
              <Button
                loading={updateProfileStatus === 'request'}
                key="submit"
                type="primary"
                htmlType="submit"
                onClick={() => {
                  editForm
                    .validateFields()
                    .then((values) => {
                      handleEditForm(values);
                    })
                    .catch((err) => {
                      console.log('Validate Failed:', err);
                    });
                }}
              >
                Save
              </Button>
            </Form>
          </TabPane>
          <TabPane
            tabId="2"
            className=""
            style={{ paddingTop: '32px', paddingBottom: '32px' }}
          >
            <Form form={passwordForm} onFinish={handlePasswordChange}>
              <div className="card shadow-none">
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-sm-3 mt-2">
                      <h6 className="font-weight-normal mt-auto">Old Password</h6>
                    </div>
                    <div className="col-sm-5 text-secondary">
                      <Form.Item
                        key="1"
                        name="old_password"
                        rules={[
                          {
                            required: true,
                            message: 'Please do not leave blank',
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder="Old Password"
                          className="border-14"
                          size="large"
                          onChange={() =>
                            dispatch(
                              setData({
                                name: 'changePassword',
                                key: 'error',
                                value: {},
                              })
                            )
                          }
                          autoComplete="off"
                        />
                      </Form.Item>{' '}
                      {passwordError?.old_password && (
                        <div className="validation mt-0">
                          {passwordError?.old_password || ''}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-3 mt-2">
                      <h6 className="mb-0 font-weight-normal">New Password</h6>
                    </div>
                    <div className="col-sm-5 text-secondary">
                      <Form.Item
                        key="2"
                        name="new_password"
                        rules={[
                          {
                            required: true,
                            message: 'Please do not leave blank',
                          },
                        ]}
                      >
                        <Input.Password
                          className="border-14"
                          size="large"
                          placeholder="New Password"
                          onChange={(e) => {
                            handleConfirmPassword(e, 'new');
                          }}
                          autoComplete="off"
                        />
                      </Form.Item>{' '}
                      {passwordError?.new_password && (
                        <div className="validation">
                          {passwordError?.new_password || ''}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-3 mt-2">
                      <h6 className="mb-0 font-weight-normal">Confirm Password</h6>
                    </div>
                    <div className="col-sm-5 text-secondary">
                      <Form.Item
                        key="3"
                        name="confirm_password"
                        rules={[
                          {
                            required: true,
                            message: 'Please do not leave blank',
                          },
                        ]}
                      >
                        <Input.Password
                          className="border-14"
                          size="large"
                          placeholder="Confirm Password"
                          type="password"
                          // className="form-control w-100"
                          onChange={(e) => handleConfirmPassword(e, 'confirm')}
                          value={confirmPassword || ''}
                          autoComplete="off"
                        />
                      </Form.Item>{' '}
                      {error && <div className="validation">{error || ''}</div>}
                    </div>
                  </div>
                  <Form.Item>
                    <Button
                      key="submit"
                      type="primary"
                      htmlType="submit"
                      className="ant-btn ant-btn-primary rounded mt-4 ml-2 d-flex px-4"
                      value="Update"
                    >
                      Update
                    </Button>
                  </Form.Item>
                </div>
              </div>
            </Form>
          </TabPane>
        </TabContent>
      </div>
    </>
  );
};

export default ProfileSettingsComponent;
